module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.2dd0a1de.eot";